import ConfigSidebar from "@/components/config_components/ConfigSidebar/ConfigSidebar.vue";
import navbar from "@/components/config_components/Navbar/NavBar.vue";

export default {
  name: 'ConfigsLayout',
  components: {
    ConfigSidebar,
    navbar
  },
  data: () => ({
    is_sidebar_hidden: false,
    show_backdrop: false,
    show_mobile_drawer: false,
    isLargeScreen: window.innerWidth >= 1200
  }),
  computed: {
    should_hide_sidebar() {
      const hidden_routes = ['/', '/login'];
      return Boolean(this.$route.meta?.hideSidebar) || hidden_routes.includes(this.$route.path);
    },
    should_hide_navbar() {
      return Boolean(this.$route.meta?.hideNavbar);
    },
    show_navbar_overlap() {
      return !this.should_hide_navbar && !this.should_hide_sidebar && !this.is_sidebar_hidden && this.isLargeScreen;
    }
  },
  watch: {
    '$route.fullPath'() {
      this.close_mobile_sidebar();

      if (this.should_hide_sidebar) {
        this.is_sidebar_hidden = false;
      }
    }
  },
  mounted() {
    this.handle_resize();
    window.addEventListener('resize', this.handle_resize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handle_resize);
    document.body.classList.remove('mobile-drawer-open');
  },
  methods: {
    handle_resize() {
      this.isLargeScreen = window.innerWidth >= 1200;

      if (window.innerWidth >= 992) {
        this.close_mobile_sidebar();
      }
    },
    close_mobile_sidebar() {
      this.show_mobile_drawer = false;
      document.body.classList.remove('mobile-drawer-open');
    },
    toggle_sidebar() {
      this.show_mobile_drawer = !this.show_mobile_drawer;
      document.body.classList.toggle('mobile-drawer-open', this.show_mobile_drawer);
    }
  }
}
